/**
 * Created by shamim.ahsan on 6/13/2019.
 */
export class InboxQueries {
  public static getAllInboxLabels(): any {
    return {
      'query': '{mailLabels{id,isDefault, order, title, type}}'
    };
  }
}
